import addRoute from '@/router/add-route';

const Guides = () => import('@/modules/guides/guides.vue');
const GuideNotificationTemplate = () => import('@/modules/guides/guide-notification-template.vue');

const guides = [
    addRoute({
        name: 'guides',
        path: '/guides',
        component: Guides,
    }),
    addRoute({
        name: 'guide-notification-template',
        path: '/guides/notification-template',
        component: GuideNotificationTemplate,
    }),
];

export default guides;
